import * as React from 'react'

import Svg, {
  Defs,
  LinearGradient,
  Path,
  RadialGradient,
  Stop,
} from 'react-native-svg'

function Earphones(props) {
  return (
    <Svg
      width={38}
      height={38}
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M7.11 17.736c-2.275 0-4.119-1.905-4.119-4.255 0-2.35 1.844-4.255 4.118-4.255H22.89c2.274 0 4.118 1.905 4.118 4.255 0 2.35-1.844 4.255-4.118 4.255"
        fill="url(#paint0_radial_1363_21550)"
      />
      <Path
        d="M24.14 9.426c.612.742.982 1.704.982 2.755 0 2.35-1.844 4.256-4.118 4.256H5.224c-.437 0-.857-.07-1.251-.2.755.917 1.88 1.5 3.137 1.5l7.89.649 7.89-.65c2.274 0 4.118-1.905 4.118-4.255 0-1.9-1.204-3.508-2.867-4.055z"
        fill="#C09C6B"
      />
      <Path
        d="M18.417 17.736h-6.834v-1.211c0-.625.49-1.131 1.094-1.131h4.645c.605 0 1.095.506 1.095 1.13v1.212z"
        fill="#957C5B"
      />
      <Path
        d="M11.583 16.437v1.3l3.417.649 3.417-.65v-1.3h-6.834z"
        fill="#957C5A"
      />
      <Path
        d="M22.235 31H7.765c-3.155 0-5.712-2.642-5.712-5.902v-5.487c0-1.035.812-1.875 1.814-1.875h22.266c1.002 0 1.814.84 1.814 1.875v5.487c0 3.26-2.557 5.902-5.712 5.902z"
        fill="url(#paint1_linear_1363_21550)"
      />
      <Path
        d="M26.133 17.736h-.159c.056.181.087.375.087.576v5.486c0 3.26-2.557 5.903-5.712 5.903H5.88a5.534 5.534 0 01-2.16-.438A5.604 5.604 0 007.765 31h14.47c3.155 0 5.713-2.643 5.713-5.902V19.61c0-1.035-.813-1.875-1.815-1.875z"
        fill="#3E80D1"
      />
      <Path
        d="M18.434 27.53h-6.867c-.886 0-1.604-.742-1.604-1.658 0-.915.718-1.657 1.604-1.657h6.867c.886 0 1.604.742 1.604 1.657 0 .916-.718 1.658-1.604 1.658z"
        fill="#3E80D1"
      />
      <Path
        d="M18.433 24.214h-.006c.025.116.038.236.038.359 0 .915-.718 1.657-1.604 1.657H10c.159.744.8 1.3 1.566 1.3h6.867c.886 0 1.604-.742 1.604-1.658 0-.915-.718-1.658-1.604-1.658z"
        fill="#85BBFD"
      />
      <Path
        d="M14.83 21.729c.499 0 .904-.43.904-.96 0-.531-.405-.961-.905-.961s-.904.43-.904.96.405.96.904.96z"
        fill="#fff"
      />
      <Path
        d="M4.854 5.79s.366 2.785 2.616 6.826c.15.27.438.358.669.202l.946-.639c.266-.18.356-.606.195-.929-.525-1.054-1.549-3.324-1.64-5.148L4.854 5.79z"
        fill="url(#paint2_linear_1363_21550)"
      />
      <Path
        d="M26.584 5.79s-.35 2.785-2.506 6.826c-.144.27-.42.358-.64.202l-.907-.639c-.255-.18-.34-.606-.187-.929.503-1.054 1.484-3.324 1.572-5.148l2.668-.312z"
        fill="url(#paint3_linear_1363_21550)"
      />
      <Path
        d="M11.875.521h-.556c-.311 0-.563.26-.563.582 0 .082-.098.121-.152.06C10.267.782 9.301 0 7.038 0 4.044 0 3.687 2.182 3.687 3.06c0 .88.094 4.039 3.534 4.039 2.265 0 3.08-.79 3.372-1.33.044-.081.163-.049.163.044v.541c0 .321.252.582.563.582h.556c1.314 0 2.379-1.1 2.379-2.458v-1.5c0-1.357-1.065-2.457-2.379-2.457z"
        fill="#3E80D1"
      />
      <Path
        d="M11.875.52h-.557c-.31 0-.562.261-.562.582 0 .083-.098.122-.152.061l-.011 4.606c.044-.081.163-.049.163.044v.541c0 .321.252.582.563.582h.556c1.314 0 2.379-1.1 2.379-2.458v-1.5c0-1.357-1.065-2.457-2.379-2.457z"
        fill="url(#paint4_linear_1363_21550)"
      />
      <Path
        d="M19.879.521h.556c.311 0 .563.26.563.582 0 .082.098.121.152.06C21.487.782 22.453 0 24.716 0c2.994 0 3.351 2.182 3.351 3.06 0 .88-.094 4.039-3.534 4.039-2.265 0-3.08-.79-3.372-1.33-.044-.081-.163-.049-.163.044v.541a.572.572 0 01-.563.582h-.556c-1.314 0-2.379-1.1-2.379-2.458v-1.5c0-1.357 1.065-2.457 2.379-2.457z"
        fill="#3E80D1"
      />
      <Path
        d="M19.879.52h.556c.311 0 .563.261.563.582 0 .083.098.122.152.061l.011 4.606c-.044-.081-.163-.049-.163.044v.541a.572.572 0 01-.563.582h-.556c-1.314 0-2.379-1.1-2.379-2.458v-1.5c0-1.357 1.065-2.457 2.379-2.457z"
        fill="url(#paint5_linear_1363_21550)"
      />
      <Defs>
        <RadialGradient
          id="paint0_radial_1363_21550"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(153.168 7.227 7.127) scale(16.5839 15.1066)"
        >
          <Stop stopColor="#FFEED8" />
          <Stop offset={1} stopColor="#D59A4F" />
        </RadialGradient>
        <LinearGradient
          id="paint1_linear_1363_21550"
          x1={24.1781}
          y1={16.6844}
          x2={19.9388}
          y2={32.2336}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9BC7FE" />
          <Stop offset={1} stopColor="#378CF7" />
        </LinearGradient>
        <LinearGradient
          id="paint2_linear_1363_21550"
          x1={8.70428}
          y1={5.22624}
          x2={4.29775}
          y2={10.4761}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9BC7FE" />
          <Stop offset={1} stopColor="#378CF7" />
        </LinearGradient>
        <LinearGradient
          id="paint3_linear_1363_21550"
          x1={22.8959}
          y1={5.22624}
          x2={27.3313}
          y2={10.2886}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9BC7FE" />
          <Stop offset={1} stopColor="#378CF7" />
        </LinearGradient>
        <LinearGradient
          id="paint4_linear_1363_21550"
          x1={13.7208}
          y1={0.0121391}
          x2={9.69102}
          y2={4.33277}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9BC7FE" />
          <Stop offset={1} stopColor="#378CF7" />
        </LinearGradient>
        <LinearGradient
          id="paint5_linear_1363_21550"
          x1={18.0331}
          y1={0.0121391}
          x2={22.0629}
          y2={4.33277}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9BC7FE" />
          <Stop offset={1} stopColor="#378CF7" />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}

export default Earphones
